import { render, staticRenderFns } from "./OfficerDetailsNotes.vue?vue&type=template&id=2c899cb0"
import script from "./OfficerDetailsNotes.vue?vue&type=script&lang=js"
export * from "./OfficerDetailsNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports